import {CustomLanding36252} from './36252'

export const getCustomLanding = (): React.FC => {
  const urlParams = new URLSearchParams(window.location.search)
  const campaign = urlParams.get('campaign')
  const p = urlParams.get('p')
  if (campaign === '3862' && p?.split('_')[0] === '36252' && window.location.host.includes('mau')) {
    return CustomLanding36252
  }

  return () => null
}
